"use client"

import { HiArrowPath, HiCheckCircle, HiExclamationTriangle, HiInformationCircle, HiXCircle } from "react-icons/hi2"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{ className: "pointer-events-auto" }}
      icons={{
        success: <HiCheckCircle className="size-4" />,
        info: <HiInformationCircle className="size-4" />,
        warning: <HiExclamationTriangle className="size-4" />,
        error: <HiXCircle className="size-4" />,
        loading: <HiArrowPath className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
